// import AOS from 'aos';
// import 'aos/dist/aos.css';
import styled from 'styled-components';
import React, { useEffect } from 'react';
import HopitalContextProvider from '../../context/chatbot/HospitalContextApi';
import ContextProvider from '../../context/chatbot/QuestionContextApi';
import Search from './Conversation/Search';
import ChatContent from './ChatContent';
import Logo from './Logo/Logo';
import { IProvider } from '../../store/providers/providerTypes';

interface IProps {
  provider: IProvider | null;
  onCloseChatbot: (status: boolean) => void;
  companyId: number | null;
}

const PageContentContainer = styled.div`
  width: 100vw;
  height: 100vh;

  @media screen and (max-width: 600px) {
    height: 90vh;
    margin: auto;
  }
`;

const StyledAppLayout = styled.div`
  margin: 1.5rem auto !important;
  display: flex !important;
  flex-direction: column !important;
  background-color: var(--exact-white) !important;
  padding: 1rem 1.5rem !important;
  box-shadow: 0 1rem 2rem #cccccc !important;
  width: 95%;
  height: 80vh;

  @media only screen and (width >= 40rem) {
    height: 87vh !important;
  }

  @media only screen and (width >= 48rem) {
    width: 90% !important;
  }
`;

const ViraPage: React.FC<IProps> = ({
  provider,
  onCloseChatbot,
  companyId,
}) => {
  // const { providerName } = useParams();
  useEffect(() => {
    // AOS.init({
    //   duration: 500,
    //   easing: 'ease-out-cubic',
    //   offset: 0,
    // });
  }, []);

  return (
    <HopitalContextProvider
      provider={provider!}
      onChangeChatStatus={onCloseChatbot}
    >
      <ContextProvider providerId={provider!.id}>
        <PageContentContainer>
          <Logo companyId={companyId as number} />
          <StyledAppLayout className="rounded-3xl font-light text-sm">
            <ChatContent />
            <Search />
          </StyledAppLayout>
        </PageContentContainer>
      </ContextProvider>
    </HopitalContextProvider>
  );
};

export default ViraPage;
